export const homepageBlocks = {
  desktop: {
    masthead: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'masthead',
            className: 'mx-auto u-center w-full max-w-[1100px] mb-4',
            lazy: false,
          },
        },
        {
          componentInfo: {
            type: 'Adblock',
            className: 'mx-auto mb-3.5 u-center inline',
            cid: '924288',
            size: '970x250',
          },
        },
        {
          componentInfo: {
            type: 'Adblock',
            style: 'top: 120px; left: 50px; width: 0; height: 0;',
            cid: '1023399',
            size: '160x600',
            fixed: true,
            className: 'fixed',
          },
        },
        {
          componentInfo: {
            type: 'Yandex',
            className: 'mx-auto u-center w-full max-w-[1100px] mb-4',
          },
        },
      ],
    },
    mansetalti: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            class: 'mx-auto mb-3.5 u-center w-full max-w-[1100px]',
            'unit-name': 'mansetAlti',
          },
        },
      ],
    },
    pageskinLeft: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'pageskinLeft',
            class: 'sticky',
            style: 'top: 100px',
            lazy: false,
          },
        },
      ],
    },
    pageskinRight: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'pageskinRight',
            class: 'sticky',
            style: 'top: 100px',
            lazy: false,
          },
        },
      ],
    },
    bodyBottom: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'interstitial',
            style: 'width: 1px; height: 1px',
            lazy: false,
          },
        },
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'datacollect',
            style: 'width: 1px; height: 1px',
            lazy: false,
          },
        },
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'sliderArasi',
            lazy: false,
          },
        },
      ],
    },
    mastheadler: {
      showAt: [3, 8, 14],
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'masthead2',
          },
          showAt: 3,
        },
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'masthead3',
          },
          showAt: 8,
        },
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'masthead4',
          },
          showAt: 14,
        },
      ],
    },
    trendler: {
      showAt: [(index) => index % 8 === 0, (index) => index % 8 === 2],
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'trendTop',
            style: 'width: 538px; border-radius: 6px; overflow: hidden',
          },
          showAt: (index) => index % 8 === 0,
        },
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'trendMiddle',
            style: 'width: 538px; border-radius: 6px; overflow: hidden',
          },
          showAt: (index) => index % 8 === 2,
        },
      ],
    },
    widget10: {
      showAt: [(index) => index % 8 === 0, (index) => index % 8 === 2],
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'widget10Top',
            style: 'width: 538px; border-radius: 6px; overflow: hidden',
          },
          showAt: (index) => index % 8 === 0,
        },
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'widget10Middle',
            style: 'width: 538px; border-radius: 6px; overflow: hidden',
          },
          showAt: (index) => index % 8 === 2,
        },
      ],
    },
    widget6: {
      showAt: [(index) => index % 5 === 3],
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'widget6Middle',
            style: 'width: 351px; align-self: baseline; border-radius: 6px; overflow: hidden;',
          },
          showAt: (index) => index % 5 === 3,
        },
      ],
    },
  },
  mobile: {
    masthead: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'masthead',
            className: 'text-center u-center mx-auto',
            lazy: false,
          },
        },
        {
          componentInfo: {
            type: 'Yandex',
            className: 'text-center u-center mx-auto',
          },
        },
      ],
    },
    mansetalti: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'mansetAlti',
            class: 'u-center text-center mb-2.5',
          },
        },
      ],
    },
    anasayfaBTF: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'anasayfaBTF',
            class: 'u-center mb-2.5',
          },
        },
      ],
    },
    haberler: {
      showAt: [3, 9, 15, 21],
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'haberlerTop',
            class: 'w-full',
          },
          showAt: 3,
        },
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'haberlerMiddle1',
            class: 'w-full',
          },
          showAt: 9,
        },
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'haberlerMiddle2',
            class: 'w-full',
          },
          showAt: 15,
        },
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'haberlerBottom',
            class: 'w-full',
          },
          showAt: 21,
        },
      ],
    },
    bodyBottom: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'datacollect',
            style: 'width: 1px; height: 1px',
            lazy: false,
          },
        },
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'appPromo',
            style: 'width: 1px; height: 1px',
            lazy: false,
          },
        },
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'interstitial',
            style: 'width: 1px; height: 1px',
            lazy: false,
          },
        },
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'sliderArasi',
            lazy: false,
          },
        },
      ],
    },
    mastheadler: {
      showAt: [1, 3],
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'masthead2',
          },
          showAt: 1,
        },
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'masthead3',
          },
          showAt: 3,
        },
      ],
    },
    trendler: {
      showAt: [(index) => index % 8 === 1, (index) => index % 8 === 3],
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'trendTop',
            class: 'w-full',
          },
          showAt: (index) => index % 8 === 1,
        },
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'trendMiddle',
            class: 'w-full',
          },
          showAt: (index) => index % 8 === 3,
        },
      ],
    },
    widget10: {
      showAt: [(index) => index % 8 === 1, (index) => index % 8 === 3],
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'widget10Top',
            class: 'w-full',
          },
          showAt: (index) => index % 8 === 1,
        },
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'widget10Middle',
            class: 'w-full',
          },
          showAt: (index) => index % 8 === 3,
        },
      ],
    },
    widget6: {
      showAt: [(index) => index % 5 === 3],
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'widget6Middle',
            class: 'w-full',
          },
          showAt: (index) => index % 5 === 3,
        },
      ],
    },
  },
};
